export default function () {
  let $setDiagnosisForm = $("#set-case-diagnosis-form");
  $setDiagnosisForm.off();
  $("#cases_panel").on("click", ".set-diagnosis", function (ev) {
    ev.stopPropagation();
    let case_id = $(this).attr("data-case-id");
    let tissue = $(this).attr("data-tissue");
    $setDiagnosisForm.data("case-id", case_id);
    $setDiagnosisForm.data("tissue", tissue.toLowerCase());
    $setDiagnosisForm.find("h3 strong").text(case_id);
    $("#prostate-diagnosis-fields").toggle(tissue.toLowerCase() === "prostate");
    $("#breast-diagnosis-fields").toggle(tissue.toLowerCase() !== "prostate");
    $setDiagnosisForm.show();
    $("#set-case-gleason").val("0");
    $("#set-case-diagnosis, #set-breast-case-diagnosis").val("").change();
  });

  $setDiagnosisForm.on("click", ".submit", function (ev) {
    ev.preventDefault();
    if (confirm(window.app.t("fast_track.confirm"))) {
      $("#container").addClass("loading");
      $.post(
        `set_diagnosis/${$setDiagnosisForm
          .data("case-id")
          .toString()
          .replace("/", "[@slash]")
          .replace("#", "[@pound]")}`,
        getDiagnosisData($setDiagnosisForm.data("tissue")),
        function () {}
      )
        .done(() => {
          $setDiagnosisForm.hide();
          setTimeout(function () {
            $("#container").removeClass("loading");
            // reload cases in vue
            //   get_cases();
            utils.eventBridgeApi("update-cases");
          }, 5000);
        })
        .fail(() => {
          $setDiagnosisForm.hide();
          $("#container").removeClass("loading");
        });
    }
  });

  const getDiagnosisData = function (tissueType) {
    if (tissueType.toLowerCase() === "prostate") {
      return {
        data: JSON.stringify({
          caseDiagnosisType: "ProstateCaseDiagnosis",
          prostateDiagnosis: $("#set-case-diagnosis").val(),
          gleason: $("#set-case-gleason").val(),
        }),
      };
    } else {
      return {
        data: JSON.stringify({
          caseDiagnosisType: "BreastCaseDiagnosis",
          breastDiagnosis: $("#set-breast-case-diagnosis").val(), // ['Benign', 'Cancer']
          breastCancerClasses: (() => {
            const checkedValues = [];
            $("#breast-diagnosis-fields input:checkbox:checked").each((i, e) =>
              checkedValues.push(e.value)
            );
            return checkedValues.length ? checkedValues : undefined;
          })(), // ["ADH", "DCIS", "IDC", "ILC", "Other Invasive"]
          dcisGrade: $("#ftf-dcis").is(":checked")
            ? parseInt($('[name="ftf-dcis-grade"]:checked').val())
            : undefined, // [0, 1, 2, 3]
        }),
      };
    }
  };

  $setDiagnosisForm.on("click", ".close", function () {
    $setDiagnosisForm.hide();
  });

  $setDiagnosisForm.on("change", "#set-case-diagnosis", function () {
    $setDiagnosisForm.find(".submit").prop("disabled", !$(this).val());
    if ($(this).val() === "Adenocarcinoma") {
      $("#set-case-gleason").show().change();
    } else {
      $("#set-case-gleason").val(0).hide();
    }
  });

  $setDiagnosisForm.on("change", "#set-breast-case-diagnosis", function () {
    $setDiagnosisForm.find(".submit").prop("disabled", true);
    $("#set-case-breast-classes input").prop("checked", false).change();
    if ($(this).val() === "Cancer") {
      $("#set-case-breast-classes").show();
      $setDiagnosisForm.find(".submit").prop("disabled", true);
    } else if ($(this).val() === "Benign") {
      $("#set-case-breast-classes").hide();
      $setDiagnosisForm.find(".submit").prop("disabled", false);
    } else {
      $("#set-case-breast-classes").hide();
      $setDiagnosisForm.find(".submit").prop("disabled", true);
    }
  });

  $setDiagnosisForm.on("change", "#set-case-gleason", function () {
    if ($("#set-case-diagnosis").val() === "Adenocarcinoma") {
      $setDiagnosisForm.find(".submit").prop("disabled", !$(this).val());
    }
  });

  $setDiagnosisForm.on("change", "#ftf-dcis", function () {
    $("#ftf-dcis-grade-selection input").prop("checked", false);
    $("#ftf-dcis-grade-selection").toggle($(this).is(":checked"));
  });

  $setDiagnosisForm.on("change", "#set-case-breast-classes input", function () {
    $setDiagnosisForm.find(".submit").prop("disabled", !checkBreastDiagnosisFormValidity());
  });

  function checkBreastDiagnosisFormValidity() {
    let isValid = false;
    let cancerClasses = [];
    $("#breast-diagnosis-fields input:checkbox:checked").each((i, e) =>
      cancerClasses.push(e.value)
    );
    if (cancerClasses.length) {
      if (!$("#ftf-dcis").is(":checked")) {
        isValid = true;
      } else if ($('[name="ftf-dcis-grade"]:checked').val()) {
        isValid = true;
      }
    }
    return isValid;
  }
}
